import { IQuestionPlainData } from "packages/survey-core/src/question"
import styles from "./styles.module.scss"
import classNames from "classnames"
import { Collapse } from "antd"
import { useTranslation } from "react-i18next"

interface IProps {
  questionType: IQuestionPlainData["questionType"]
  choice: IQuestionPlainData
}

const Choices: React.FC<IProps> = ({ choice, questionType }) => {
  const { t } = useTranslation()

  switch (questionType) {
    case "checkbox":
    case "radiogroup":
      return (
        <div className={styles.collapseItem} key={choice.name}>
          <div
            className={classNames(
              "body-heavy",
              styles.textContainer,
              styles.choiceItemText
            )}
          >
            {t("global.choice")}
          </div>
          <div
            className={classNames(
              styles.textContainer,
              styles.checkboxTypeText,
              styles.choiceItemText
            )}
          >
            {choice.displayValue}
          </div>
        </div>
      )
    case "paneldynamic":
      if (!choice.data || choice.data.length === 0) return null
      if (choice.data.some((panel) => panel.questionType === "dropdown"))
        return (
          <Collapse
            items={(choice.data || [])
              .filter((panel) => panel.questionType === "dropdown")
              .map((panel, idx) => ({
                key: panel.value,
                label: (
                  <div className={styles.collapseHeader}>
                    <div
                      className={classNames(
                        "body-heavy",
                        styles.textContainer,
                        styles.label
                      )}
                    >
                      {t("global.choice")}
                    </div>
                    <div
                      className={classNames(
                        styles.textContainer,
                        styles.checkboxTypeText
                      )}
                    >
                      {panel.displayValue}
                    </div>
                  </div>
                ),
                children: (
                  <div className={styles.collapseHeader}>
                    <div
                      className={classNames(
                        "body-heavy",
                        styles.textContainer,
                        styles.label
                      )}
                    >
                      {t("global.description")}
                    </div>
                    <div className={classNames(styles.textContainer)}>
                      {choice.data?.[idx + 1]?.displayValue}
                    </div>
                  </div>
                ),
              }))}
          />
        )
      return (
        <div className={styles.collapseItem} key={choice.data?.[0].name}>
          <div
            className={classNames(
              "body-heavy",
              styles.textContainer,
              styles.choiceItemText
            )}
          >
            {t("global.choice")}
          </div>
          <div
            className={classNames(
              styles.textContainer,
              styles.checkboxTypeText,
              styles.choiceItemText
            )}
          >
            {choice.data?.[0].displayValue}
          </div>
        </div>
      )
    default:
      return <b>Unhandled question type</b>
  }
}

export default Choices
